import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser } from 'src/types/shared/AdminUser';

export const fetchAllAdminUsersRequest = createAction('fetchAllAdminUsersRequest');
export const fetchAllAdminUsersSuccess = createAction<AdminUser[]>('fetchAllAdminUsersSuccess');
export const fetchAllAdminUsersFailure = createAction('fetchAllAdminUsersFailure');

export const fetchAllAdminUsers = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllAdminUsersRequest());
    try {
        const { data }: Response = await api.get('admin/admins');

        dispatch(fetchAllAdminUsersSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllAdminUsersFailure, e);
    }
};

interface Response {
    data: AdminUser[];
}
